export { default } from './carousel';


//////////////////
// WEBPACK FOOTER
// ./node_modules/rmc-nuka-carousel/es/index.js
// module id = 294
// module chunks = 0